<template>

<div class="advanced-switch" :data-count="count">

	<div class="advanced-switch-item" :class="{'is-active': mode === 3}" v-on:click="onClick(3)" v-if="hasSource">
		<span>Source</span>
		<span v-if="sourceCount" class="is-count">{{ sourceCount }}</span>
	</div>

	<div class="advanced-switch-item" :class="{'is-active': mode === 1, 'is-disabled': !sourceCount && hasSource}" v-on:click="onClick(1)">
		<span>Standard</span>
		<span v-if="normalCount" class="is-count">{{ normalCount }}</span>
	</div>

	<div class="advanced-switch-item" :class="{'is-active': mode === 2, 'is-disabled': !sourceCount && hasSource}" v-on:click="onClick(2)" v-if="hasAdvanced">
		<span>Advanced</span>
		<span v-if="advancedCount" class="is-count">{{ advancedCount }}</span>
	</div>

</div>

</template>

<script>

export default {

    props: ['mode', 'hasAdvanced', 'hasSource', 'filter'],

	computed: {

		count: function() {

			return 1 + ((this.hasAdvanced) ? 1 : 0) + ((this.hasSource) ? 1 : 0)

		},

		sourceCount: function() {

			if(!this.hasSource) return 0

			return (this.$store.getters['filter/' + this.filter + '/source/collection'] + this.$store.getters['filter/' + this.filter + '/source/ratings'] + this.$store.getters['filter/' + this.filter + '/source/plays'] + this.$store.getters['filter/' + this.filter + '/source/all'])

		},

		advancedCount: function() {

			return this.$store.getters['filter/' + this.filter + '/advanced/count']

		},

		normalCount: function() {

			return this.$store.getters['filter/' + this.filter + '/active/count'] - this.advancedCount - this.sourceCount

		}

	},

    methods: {

        onClick: function(n) {

            this.$emit('change', n)

        }

    }

}

</script>

<style scoped>

.advanced-switch {
	display: grid;
	width: 100%;
	grid-template-columns: 1fr 1fr;
	background-color: #4b7185;
    border-bottom: 1px solid #2b5870;
	z-index: 300;
}

.advanced-switch[data-count="3"] {
	grid-template-columns: 1fr 1fr 1fr;
}

.is-mobile .advanced-switch {
	box-shadow: none;
	border: 0px;
	background-color: #fff;
	box-shadow: rgba(9, 30, 66, 0.15) 0px 8px 8px -2px;
	grid-gap: 5px;
}

.advanced-switch-item {
	font-size: 16px;
	height: 48px;
	line-height: 48px;
	user-select: none;
	cursor: pointer;
	color: #fff;
	font-weight: 400;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	border-bottom: 4px solid transparent;
}

.advanced-switch-item.is-disabled {
	opacity: 0.25;
	pointer-events: none;
}

.is-mobile .advanced-switch-item {
	padding-top: 2px;
	height: 40px;
	color: #343434;
	font-size: 14px;
	line-height: 38px;
	user-select: none;
	cursor: pointer;
	text-align: center;
	font-weight: 400;
	border-bottom: 4px solid transparent;
}

.is-desktop .advanced-switch-item:hover {
	border-bottom: 4px solid #fff;
	color: #fff;
}

.advanced-switch-item.is-active,
.advanced-switch-item.is-active:hover {
	border-bottom: 4px solid #ffc563;
	color: #ffc563;
	font-weight: 500;
}

.advanced-switch-item .is-count {
	background-color: #fff;
    border-radius: 4px;
    color: #333;
    font-size: 12px;
    min-width: 16px;
    height: 16px;
    padding: 0px 4px;
	box-sizing: border-box;
    text-align: center;
    font-weight: 500;
    line-height: 16px;
}

.advanced-switch-item.is-active .is-count {
	background-color: #ffc563;
}

</style>